import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-eecb9fce")

_pushScopeId("data-v-eecb9fce")
const _hoisted_1 = {
  key: 0,
  id: "booking-v4-goods-commodity",
  "data-testid": "booking-v4-goods-commodity",
  class: "flex flex-col gap-2"
}
const _hoisted_2 = { class: "flex items-center justify-between mb-1" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "text-xs font-semibold text-black-lp-300" }
const _hoisted_5 = { class: "ml-1 relative" }
const _hoisted_6 = /*#__PURE__*/_createVNode("svg", {
  class: "w-3.5 h-3.5 ml-0.5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2.5",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_7 = { class: "border border-gray-lp-400 rounded-2xl grid grid-cols-1 lg:grid-cols-12 items-stretch" }
const _hoisted_8 = { class: "lg:col-span-6 bg-gray-lp-1000 border-b lg:border-b-0 lg:border-r border-gray-lp-400 p-3 flex items-center rounded-t-2xl lg:rounded-tr-none lg:rounded-l-2xl relative z-0" }
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = { class: "w-full flex flex-row justify-between items-center py-0.5" }
const _hoisted_11 = { class: "text-xs font-medium" }
const _hoisted_12 = { class: "flex flex-row ml-1 items-center" }
const _hoisted_13 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-8px px-1 py-0.5"
}
const _hoisted_14 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-8px px-1 py-0.5"
}
const _hoisted_15 = { class: "flex flex-row items-center mr-1.5" }
const _hoisted_16 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-8px px-1 py-0.5"
}
const _hoisted_17 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-8px px-1 py-0.5"
}
const _hoisted_18 = { class: "lg:col-span-6 bg-white p-3 flex items-center rounded-b-2xl lg:rounded-bl-none lg:rounded-r-2xl recommendation-container relative" }
const _hoisted_19 = { class: "grid grid-cols-3 gap-2 w-full" }
const _hoisted_20 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-8px px-1 py-0.5 flex-shrink-0"
}
const _hoisted_21 = {
  key: 1,
  class: "bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-8px px-1 py-0.5 flex-shrink-0"
}
const _hoisted_22 = { class: "text-xs overflow-ellipsis whitespace-nowrap overflow-hidden flex-1 text-12px" }
const _hoisted_23 = { class: "w-full flex flex-col text-12px" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_ctx.configCommodity.rule !== _ctx.configValidationForm.NON_SHOW)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("bookingV4.goods.commodity.title")), 1),
            _createVNode("div", _hoisted_5, [
              _createVNode("img", {
                onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenTooltipCommodity = true)),
                onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenTooltipCommodity = false)),
                src: 
              _ctx.isOpenTooltipCommodity
                ? require('@/app/ui/assets/svg/info-red.svg')
                : require('@/app/ui/assets/svg/info.svg')
            ,
                alt: "info",
                class: "cursor-pointer"
              }, null, 40, ["src"]),
              _withDirectives(_createVNode(_component_Tooltip, {
                title: _ctx.$t('bookingV4.goods.commodity.note'),
                message: _ctx.$t('bookingV4.goods.commodity.tncBody'),
                footer: "",
                style: {"width":"280px","margin-left":"2.6em","margin-top":"-2.6em","z-index":"50"}
              }, null, 8, ["title", "message"]), [
                [_vShow, _ctx.isOpenTooltipCommodity]
              ])
            ])
          ]),
          _createVNode("button", {
            type: "button",
            "data-testid": "booking-v4-commodity-button-view-all",
            class: "flex items-center text-xs font-semibold text-red-lp-1600 hover:text-red-lp-2400",
            disabled: _ctx.disabledCommodity,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onOpenModal && _ctx.onOpenModal(...args)))
          }, [
            _createVNode("span", null, _toDisplayString(_ctx.$t("bookingV4.goods.commodity.viewAll")), 1),
            _hoisted_6
          ], 8, ["disabled"])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_SelectSearch, {
                "data-testid": "booking-v4-commodity-select",
                options: _ctx.searchOptions,
                isLoading: _ctx.loading,
                onFilter: _ctx.onSearch,
                onFocus: _ctx.onInputFocus,
                onBlur: _ctx.onInputBlur,
                onClose: _ctx.onInputBlur,
                keyName: "label",
                keyValue: "code",
                placeholder: _ctx.$t('bookingV4.goods.commodity.placeholder'),
                modelValue: _ctx.selectedOption,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedOption = $event)),
                isShowErrorMessage: true,
                isShowErrorIndicator: !!_ctx.errors.commodity,
                errorCaption: _ctx.errors.commodity,
                onChange: _ctx.onSelectChange,
                onClear: _ctx.onClearSearch,
                idInput: "booking-v4-commodity",
                autoUpDown: "",
                isSearchIcon: "",
                useInfiniteScroll: "",
                onScrolled: _ctx.onLoadMore,
                isFirstLanding: true,
                errorMessage: _ctx.$t('bookingV4.goods.commodity.notFound'),
                customClassInput: "bg-white",
                isDisabled: _ctx.disabledCommodity,
                disabledBackground: _ctx.disabledCommodity
              }, {
                "custom-option": _withId(({ item }) => [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, _toDisplayString(item.label), 1),
                    _createVNode("div", _hoisted_12, [
                      (item.isQuarantine)
                        ? (_openBlock(), _createBlock("span", _hoisted_13, " K "))
                        : _createCommentVNode("", true),
                      (item.isDangerousGoods)
                        ? (_openBlock(), _createBlock("span", _hoisted_14, " DG "))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                "selected-prefix": _withId(({ selected }) => [
                  _createVNode("div", _hoisted_15, [
                    (selected && selected.isQuarantine)
                      ? (_openBlock(), _createBlock("span", _hoisted_16, " K "))
                      : _createCommentVNode("", true),
                    (selected && selected.isDangerousGoods)
                      ? (_openBlock(), _createBlock("span", _hoisted_17, " DG "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["options", "isLoading", "onFilter", "onFocus", "onBlur", "onClose", "placeholder", "modelValue", "isShowErrorIndicator", "errorCaption", "onChange", "onClear", "onScrolled", "errorMessage", "isDisabled", "disabledBackground"])
            ])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.recommendedCommodities, (recommend) => {
                return (_openBlock(), _createBlock("div", {
                  key: recommend.id || recommend.code
                }, [
                  _createVNode("label", {
                    "data-testid": 
                `booking-v4-commodity-chip-${recommend.id || recommend.code}`
              ,
                    class: [
                'border rounded-lg px-2 py-1 flex items-center gap-1 cursor-pointer h-[38px] transition-colors',
                _ctx.disabledCommodity ? 'cursor-not-allowed opacity-50' : '',
                _ctx.isSelectedRecommendation(recommend)
                  ? 'border-red-lp-100 bg-pink-lp-200 text-red-lp-1600 font-semibold'
                  : 'border-gray-lp-400 bg-white text-black-lp-300 hover:bg-gray-lp-1800 hover:text-gray-lp-300'
              ],
                    onMouseenter: ($event: any) => (_ctx.toggleTooltip($event, recommend.code)),
                    onMouseleave: ($event: any) => (_ctx.toggleTooltip($event, recommend.code)),
                    onClick: ($event: any) => (_ctx.onChoose(recommend))
                  }, [
                    _createVNode("input", {
                      type: "radio",
                      name: `commodity-recommendation-v4`,
                      value: recommend.code,
                      checked: _ctx.isSelectedRecommendation(recommend),
                      id: `commodity-${recommend.code}-${recommend.id}`,
                      disabled: _ctx.disabledCommodity,
                      onChange: () => _ctx.onChoose(recommend),
                      class: "z-10 absolute opacity-0"
                    }, null, 40, ["value", "checked", "id", "disabled", "onChange"]),
                    (recommend.isQuarantine)
                      ? (_openBlock(), _createBlock("span", _hoisted_20, " K "))
                      : _createCommentVNode("", true),
                    (recommend.isDangerousGoods)
                      ? (_openBlock(), _createBlock("span", _hoisted_21, " DG "))
                      : _createCommentVNode("", true),
                    _createVNode("span", _hoisted_22, _toDisplayString(_ctx.ellipsisText(_ctx.displayName(recommend), 14)), 1)
                  ], 42, ["data-testid", "onMouseenter", "onMouseleave", "onClick"]),
                  _createVNode(_component_OverlayPanel, {
                    ref: recommend.code,
                    appendTo: "body",
                    style: [{"width":"190px","font-weight":"400"}, {
                backgroundColor: '#ffffff',
                color: '#4D4D4D'
              }]
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_23, [
                        _createVNode("div", null, _toDisplayString(_ctx.displayName(recommend)), 1)
                      ])
                    ]),
                    _: 2
                  }, 1536)
                ]))
              }), 128))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})